// src/utils/google-maps-loader.js
let loaderPromise = null

export default function loadGoogleMaps () {
  // 单例：已创建过就不再重复
  if (loaderPromise) return loaderPromise

  loaderPromise = new Promise((resolve, reject) => {
    // 如果页面刷新后脚本已经加在 <head> 里，但还没执行完
    if (window.google && window.google.maps) {
      return resolve(window.google.maps)
    }

    // 全局回调
    window.initGoogleMapsCallback = () => {
      resolve(window.google.maps)
      delete window.initGoogleMapsCallback
    }

    // 创建 script 标签
    const script = document.createElement('script')
    script.async = true
    script.defer = true
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBW5O79zvlDrTdKKBbpkCb4lFctuatIqCw&callback=initGoogleMapsCallback&v=weekly&language=en'
    script.onerror = reject
    document.head.appendChild(script)
  })

  return loaderPromise
}
